import { Skadekategori, skadekategoriToUrlPathName } from '../landingsside/deep-link-handler/skadekategori';

export const hovedkategoriPath = 'hovedkategori';
export const skjemaPath = 'skjema';

export const urler = () => ({
    landingssideUrl: '/',
    partner: '/partner',
    meldSkadeUrl: `/skade`,
    ettersendingUrl: `/${skjemaPath}/ettersending`,
    klageUrl: `/${skjemaPath}/klage`,
    sporsmalsflytKvitteringUrl: `/sporsmalsflyt/kvittering`,
    ettersendingKvitteringUrl: `/${skjemaPath}/ettersending/kvittering`,
    klageKvitteringUrl: `/${skjemaPath}/klage/kvittering`,

    husOgHytteUrl: `/${skadekategoriToUrlPathName(Skadekategori.HusOgHytte)}/${hovedkategoriPath}`,
    innboOgEiendelerUrl: `/${skadekategoriToUrlPathName(Skadekategori.Innbo)}/${hovedkategoriPath}`,
    degOgDineUforhetDodsfallEllerKritiskSykdomUrl: `/${skadekategoriToUrlPathName(
        Skadekategori.DegOgDineUforhetDodsfallEllerKritiskSykdom,
    )}/${hovedkategoriPath}`,
    reiseUrl: `/${skadekategoriToUrlPathName(Skadekategori.Reise)}/${hovedkategoriPath}`,
    kjoretoyUrl: `/${skadekategoriToUrlPathName(Skadekategori.Kjoretoy)}/${hovedkategoriPath}`,
    batUrl: `/${skadekategoriToUrlPathName(Skadekategori.Bat)}/${hovedkategoriPath}`,
    naringUrl: `/${skadekategoriToUrlPathName(Skadekategori.Naring)}/${hovedkategoriPath}`,
    naringNaringsbyggOgEiendelerUrl: `/${skadekategoriToUrlPathName(Skadekategori.NaringNaringsbyggOgEiendeler)}/${hovedkategoriPath}`,
    naringLosoreEiendelUrl: `/${skadekategoriToUrlPathName(Skadekategori.NaringNaringsbyggOgEiendeler)}/losore-eiendel`,
    landbrukUrl: `/${skadekategoriToUrlPathName(Skadekategori.Landbruk)}/${hovedkategoriPath}`,
    landbrukProduksjonsdyrUrl: `/${skadekategoriToUrlPathName(Skadekategori.LandbrukProduksjonsdyr)}/${hovedkategoriPath}`,
    landbrukLosoreEiendelUrl: `/landbruk/losore-eiendel`,
    landbrukDriftsbygningerUrl: `/landbruk/driftsbygninger`,
    dyrUrl: `/${skadekategoriToUrlPathName(Skadekategori.Dyr)}/${hovedkategoriPath}`,
    rettshjelpUrl: `/${skadekategoriToUrlPathName(Skadekategori.Rettshjelp)}/${hovedkategoriPath}`,
    ansvarUrl: `/${skadekategoriToUrlPathName(Skadekategori.Ansvar)}/${hovedkategoriPath}`,

    bygningNaturskadeUrl: `/bygningnaturskade`,
    bygningLekkasjerOgVannskaderUrl: `/bygningLekkasjerOgVannskader`,
    soppRateSkadedyr: `/husoghytte/soppRateSkadedyr`,
    bygningGlasskadeUrl: `/bygningGlasskade`,
    bygningBrannOgElektriskeSkaderUrl: `/bygningBrannOgElektriskeSkader`,
    bygningInnbruddOgHarverkSkaderUrl: `/bygningInnbruddOgHarverkSkader`,
    kollisjonskadeKjoretoyUrl: `/kollisjonskadeKjoretoy`,
    kjoretoyTyveriUrl: `/kjoretoytyveri`,
    skadePaParkertKjoretoyUrl: `/skadePaParkertKjoretoy`,
    andreSkaderKjoretoyUrl: `/andreSkader`,
    batKollisjonsskadeUrl: `/kollisjonsskadeBat`,
    batTyveriEllerInnbruddUrl: `/tyveriEllerInnbrudd`,
    signertFullmakt: '/signertFullmakt',
    reiseMistetSkadetStjaletUrl: '/reise/mistetskadetstjalet',
    reiseSykdomUlykkeDodsfallUrl: '/reise/sykdomulykkedodsfall',
    kattUrl: `/katt`,
    hundUrl: `/hund`,
    hestUrl: `/hest`,
    rettshjelpPrivatUrl: `/rettshjelp/privat`,
    ansvarPrivatUrl: `/ansvar/privat`,
    ansvarLandbrukNaringUrl: `/ansvar/landbruk-eller-naring`,
    invalidSessionUrl: `/ugyldig-sesjon`,
});
